import type { FormattedResolution } from '@library/types/resolutions/resolutionsList';
import { ResolutionStatus } from '@library/components/statuses';
import { cn } from '@library/component-utils/cn';

export interface ResolutionsRowProps {
  onClickResolution: ({ resolutionId }: { resolutionId: string }) => void;
  resolution: FormattedResolution;
}

export const ResolutionsRow = ({
  onClickResolution,
  resolution
}: ResolutionsRowProps) => {
  const {
    adminName,
    adminEmail,
    createdAtDate,
    createdAtTime,
    id: resolutionId,
    reason,
    status,
    type,
    updatedAtDate,
    updatedAtTime
  } = resolution;

  const isDisabled = status === 'discarded';

  const isResolutionCompleted =
    status === 'completed' || status === 'manually_completed';

  const completedOnDate = isResolutionCompleted ? updatedAtDate : '';
  const completedOnTime = isResolutionCompleted ? updatedAtTime : '';

  return (
    <div
      aria-disabled={isDisabled}
      aria-hidden="true"
      className={cn(
        'border-soFresh-140 text-soClean-110 hover:bg-soFresh-120 text-2xs relative flex h-full min-h-16 cursor-default items-center border-b pl-4 xl:text-xs',
        isDisabled ? 'pointer-events-none' : ''
      )}
      data-testid={`resolution-${resolutionId}`}
      onClick={() => onClickResolution({ resolutionId })}
      role="button"
    >
      <p className="w-[5%] px-3" data-testid="resolution-id">
        {resolutionId}
      </p>
      <p className="w-[5%] px-3" data-testid="resolution-type">
        {type}
      </p>

      <div className="w-1/5 px-3">
        <p data-testid="resolution-admin-name">{adminName}</p>
        <p className="text-soClean-160" data-testid="resolution-admin-email">
          {adminEmail}
        </p>
      </div>
      <p className="flex-1 px-3" data-testid="resolution-type">
        {reason}
      </p>
      <div className="w-[15%] px-3">
        <p data-testid="resolution-created-at-date">{createdAtDate}</p>
        <p
          className="text-soClean-160"
          data-testid="resolution-created-at-time"
        >
          {createdAtTime}
        </p>
      </div>
      <div className="w-[15%] px-3" data-testid="resolution-completed-on-date">
        <p data-testid="member-promotion-optedInAtDate">{completedOnDate}</p>
        <p
          className="text-soClean-160"
          data-testid="resolution-completed-on-time"
        >
          {completedOnTime}
        </p>
      </div>
      <div className="w-[15%] px-3" data-testid="resolution-type">
        <ResolutionStatus resolutionStatus={status} />
      </div>
    </div>
  );
};
